import { makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import clsx from "clsx";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import useBreakpoint from "../../hooks/useBreakpoint";
import { useTranslation } from "../../hooks/useTranslation";
import { tabSelectWithWarning } from "../../redux/actions/tabActions";
import TooltipControlled from "./TooltipControlled";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  rootMobile: {
    width: "100%",
  },
  title: {
    width: "90%",
    textAlign: "start",
    textTransform: "capitalize",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  titleMobile: {
    textAlign: "center",
  },
  iconContent: {
    position: "absolute",
    right: 5,
  },
  iconContentMobile: {
    top: 5,
  },
  iconButton: {
    padding: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "1.5rem",
    transition: "background 0.2s 0s ease",
    borderRadius: "50%",
    "&:hover": {
      background: "rgb(0 0 0 / 8%)",
      borderRadius: "50%",
    },
  },
  icon: { padding: 0 },
});

type TitleTabProps = {
  title: string;
  onClose: (event: any) => void;
  entry?: boolean;
  exit?: boolean;
  isMultipleExit?: boolean;
  warning?: boolean;
};

const TitleTab = ({
  title,
  onClose,
  entry,
  exit,
  isMultipleExit,
  warning,
}: TitleTabProps) => {
  const classes = useStyles();
  const { t, BundleKey } = useTranslation();
  const { isDesktop, isMobile } = useBreakpoint();
  const dispatch = useDispatch();

  const getTitle = () => {
    const subTitle = `${title.substr(0, 25)}${title.length >= 25 ? "..." : ""}`;
    return `${
      isMultipleExit
        ? t(BundleKey.TAB_MULTIPLEEXIT_TITLE)
        : entry && isDesktop
        ? t(BundleKey.TAB_HEAD_ENTRY) + " - " + subTitle
        : exit && isDesktop
        ? t(BundleKey.TAB_HEAD_EXIT) + " - " + subTitle
        : subTitle
    }`;
  };

  useEffect(() => {
    if (warning) {
      setTimeout(() => dispatch(tabSelectWithWarning(false)), 5000);
    }
  }, [warning]);

  return (
    <>
      <TooltipControlled
        open={warning}
        arrow
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={
          <React.Fragment>
            <WarningRoundedIcon />
          </React.Fragment>
        }
      >
        <div className={clsx(classes.root, { [classes.rootMobile]: isMobile })}>
          <div
            className={clsx(classes.title, { [classes.titleMobile]: isMobile })}
          >
            {getTitle()}
          </div>
        </div>
      </TooltipControlled>
      <div
        className={clsx(classes.iconContent, {
          [classes.iconContentMobile]: isMobile,
        })}
      >
        <div className={classes.iconButton} onClick={onClose}>
          <CloseIcon fontSize="small" />
        </div>
      </div>
    </>
  );
};

export default TitleTab;
